import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  const goHome = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.REACT_APP_NAVIGATE("/");
    }
  };

  const goToGovernance = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("governance");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      window.REACT_APP_NAVIGATE("/", { state: { scrollTo: "governance" } });
    }
  };

  return (
    <footer className="bg-bg-section border-t border-border mt-0">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="mb-4">
              <span className="font-serif text-2xl font-semibold text-text-headline">VantageSight</span>
            </div>
            <p className="font-sans text-[15px] text-text-muted leading-relaxed">
              Practical AI strategy, governance, adoption, and workforce readiness advisory for companies, government agencies, enterprise organizations, nonprofits, and academic institutions.
            </p>
          </div>

          <div>
            <h4 className="font-sans text-[18px] font-semibold mb-5 text-text-headline">Quick Links</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <button
                  onClick={goHome}
                  className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <Link to="/about" className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <button
                  onClick={goToGovernance}
                  className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  AI Governance
                </button>
              </li>
              <li>
                <Link to="/contact" className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-[18px] font-semibold mb-5 text-text-headline">Connect</h4>
            <ul className="flex flex-col gap-4">
              <li>
                <a
                  href="mailto:smurray@vantagesightai.com"
                  className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors flex items-center gap-2"
                >
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                  smurray@vantagesightai.com
                </a>
              </li>
              <li>
                <a
                  href="https://calendly.com/smurray-vantagesightai/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors flex items-center gap-2"
                >
                  <i className="ri-calendar-check-line w-5 h-5 flex items-center justify-center"></i>
                  Book a Consultation
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/sue-murray-3120601/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-sans text-[15px] text-text-muted hover:text-primary transition-colors flex items-center gap-2"
                >
                  <i className="ri-linkedin-box-line w-5 h-5 flex items-center justify-center"></i>
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="w-full px-4 md:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans text-[14px] text-text-muted">
            &copy; {currentYear} VantageSight AI Advisory LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" rel="nofollow" className="font-sans text-[14px] text-text-muted hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" rel="nofollow" className="font-sans text-[14px] text-text-muted hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}